import { PremiumDescriptionTextModule } from '../premium/description-text/premium-description-text.module';
import { SubscriptionsPaywall2025TemplateComponent } from './paywall2025/paywall2025.component';
import { PremiumButtonTextModule } from '../premium/button-text/premium-button-text.module';
import { SubscriptionsCatGirlTemplateComponent } from './catgirl/catgirl.component';
import { SubscriptionsOfferTemplateComponent } from './default/default.component';
import { ButtonModule } from '../controls/button/button.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SwiperModule } from 'swiper/angular';
import { NgModule } from '@angular/core';
import { SubscriptionsPaywall2025_2TemplateComponent } from './paywall2025-2/paywall2025-2.component';

@NgModule({
  declarations: [
    SubscriptionsPaywall2025TemplateComponent,
    SubscriptionsPaywall2025_2TemplateComponent,
    SubscriptionsCatGirlTemplateComponent,
    SubscriptionsOfferTemplateComponent,
  ],
  imports: [
    PremiumDescriptionTextModule,
    PremiumButtonTextModule,
    TranslateModule,
    CommonModule,
    ButtonModule,
    SwiperModule,
  ],
  exports: [
    SubscriptionsPaywall2025_2TemplateComponent,
    SubscriptionsPaywall2025TemplateComponent,
    SubscriptionsCatGirlTemplateComponent,
    SubscriptionsOfferTemplateComponent,
  ],
})
export class SubscriptionTemplatesModule {}
